import { render, staticRenderFns } from "./CustomProducts.vue?vue&type=template&id=e681b6c4&scoped=true&"
import script from "./CustomProducts.vue?vue&type=script&lang=js&"
export * from "./CustomProducts.vue?vue&type=script&lang=js&"
import style0 from "./CustomProducts.vue?vue&type=style&index=0&id=e681b6c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e681b6c4",
  null
  
)

export default component.exports